import { render } from "./BuildingView.vue?vue&type=template&id=92342e8c&scoped=true"
const script = {}

import "./BuildingView.vue?vue&type=style&index=0&id=92342e8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92342e8c"]])

export default __exports__